<template>
  <settings-modal class="card-order-user-id-edit-modal">
    <template slot="heading">Edit user ID</template>

    <v-text-field
      v-model="form.userId"
      class="t-user-id-field"
      label="User ID"
      :error-messages="getValidationErrorMessage('userId')"
    />

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-edit-card-order-user-id"
        color="primary"
        medium
        flat
        :disabled="!isFormFilled || loading"
        @click="onSaveButtonClick"
      >save</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_CARD_ORDER_UPDATE } from '@/events/cardOrders'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import IssuingApi from '@/services/Api/IssuingApi'

  // Mixins
  import form from '@/mixins/form'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'CardOrderUserIdEditModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        form: { userId: null },
        requiredFields: ['userId'],
        cardOrderUserIdUpdateApiRequest: new ApiRequest(IssuingApi.updateCardOrderUserId)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      cardOrderId () {
        return this.modal.data.cardOrderId
      },
      userId () {
        return this.modal.data.userId
      },
      loading () {
        return this.cardOrderUserIdUpdateApiRequest.loading
      },
      error () {
        return this.cardOrderUserIdUpdateApiRequest.error
      }
    },
    created () {
      this.form.userId = this.userId
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onSaveButtonClick () {
        this.cardOrderUserIdUpdateApiRequest
          .execute(this.cardOrderId, this.form.userId)
          .then(this.cardOrderUserIdUpdateSuccessHandler)
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      cardOrderUserIdUpdateSuccessHandler () {
        this.$eventHub.$emit(EVENT_CARD_ORDER_UPDATE, this.form.userId)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'User ID has been successfully edited.' }
          })
        }, 100)
      }
    }
  }
</script>
